import { useAuth } from '../../../auth/auth-context'
import useFetch from '../../../_fetch'
import { getColumns } from './columns'
import { Table } from '../_table/table'

export default function ReferenceReport() {        
    const { doFetch } = useFetch()
    const columns = getColumns()
    
    return (
        <Table 
            columns={columns} 
            getData={async (fromDate, toDate) => {
                const res = await doFetch('/data/total-transactions-by-ref', {
                    fromDate, toDate, timezoneOffsetMinutes: new Date().getTimezoneOffset()
                })
                return await res.json()
            }}
            title='Reference report'
            defaultSort='totalCommission'
        />)
}

